"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILFormItemBox = exports.ILFormItemBoxArgs = exports.ILFormBox = exports.ILFormBoxArgs = exports.SequenceNavBox = exports.SequenceNavBoxArgs = exports.SimpleBox = exports.SimpleBoxArgs = void 0;
var react_1 = __importDefault(require("react"));
var get_component_1 = require("../../shared/helpers/get-component");
var il_button_common_1 = require("../il-button/il-button.common");
var il_box_1 = require("./il-box");
var enums_1 = require("../../shared/enums");
// Simple Box
exports.SimpleBoxArgs = {
    children: 'IL Box Text',
    sx: {
        fontSize: '13px',
    },
};
exports.SimpleBox = (0, get_component_1.getComponent)(il_box_1.IlBox, exports.SimpleBoxArgs);
// Sequence Nav Box
exports.SequenceNavBoxArgs = {
    sx: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row-reverse',
        alignItems: 'center',
        backgroundColor: 'background.default',
        padding: '16px 24px',
        margin: 0,
        gap: '30px',
        borderTop: 1,
        borderTopColor: 'action.disabledBackground',
        height: '72px',
    },
    children: (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(il_button_common_1.ContainedButton, null, "Next"),
        react_1.default.createElement(il_button_common_1.TextButton, null, "Back"))),
};
exports.SequenceNavBox = (0, get_component_1.getComponent)(il_box_1.IlBox, exports.SequenceNavBoxArgs);
// ILFormBox
exports.ILFormBoxArgs = {
    sx: {
        display: 'flex',
        flex: 0,
        justifyContent: 'flex-start',
        flexDirection: 'column',
        backgroundColor: 'background.default',
        borderRadius: '0.75rem',
        maxWidth: enums_1.BreakpointsEnum.MEDIUM,
        padding: { sm: '1.5rem 0.75rem', md: '1.5rem 3rem' },
        margin: { sm: 0, md: '1rem' },
        boxShadow: 2,
    },
};
exports.ILFormBox = (0, get_component_1.getComponent)(il_box_1.IlBox, exports.ILFormBoxArgs);
// ILFormItemBox
exports.ILFormItemBoxArgs = {
    sx: {
        display: 'flex',
        flex: 1,
        justifyContent: 'flex-start',
        flexDirection: 'column',
        marginTop: '1rem',
        marginBottom: '1rem',
        gap: 2,
    },
};
exports.ILFormItemBox = (0, get_component_1.getComponent)(il_box_1.IlBox, exports.ILFormItemBoxArgs);
